import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import LandingPage from "@/pages/LandingPage";
import LegalPage from "@/pages/LegalPage";
import ThankYouPage from "@/pages/ThankYouPage";
import BookedPage from "@/pages/BookedPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/legal/:slug" element={<LegalPage />} />
        <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
        <Route path="/terms" element={<LegalPage slug="terms" />} />
        <Route path="/cancellation" element={<LegalPage slug="cancellation" />} />
        <Route path="/contact" element={<LegalPage slug="contact" />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/booked" element={<BookedPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
